import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-track"]
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "absolute bottom-10 w-full"
}
const _hoisted_5 = { class: "mb-8 flex flex-1 items-center justify-center" }

import { onBeforeUnmount, onMounted, ref, watch, Ref } from "vue";
import OcmMessenger from "ocm_mercurius_messenger";
import CloseButton from "@SharedVueComponents/CloseButton/CloseButton.vue";
import HeadlineModalMobil from "@/components/HeadlineModalMobil.vue";
import HeadlineModalDesktop from "@/components/HeadlineModalDesktop.vue";
import IntroductionText from "@/components/IntroductionText.vue";
import BottomLoginRegisterToggle from "@/components/BottomLoginRegisterToggle.vue";
import SocialLogin from "@/components/SocialLogin.vue";
import BaseTrust from "@/components/BaseTrust.vue";
import BaseFootnote from "@/components/BaseFootnote.vue";
import BenefitItems from "@/components/BenefitItems.vue";
import LoginForm from "@/components/LoginForm.vue";
import useIsMobile from "@/services/detectingMobile";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import { pushEvent } from "@/services/dataLayerLogin";
import { store } from "@/state/store";

// *************************************************** SSO AB-TEST START**********************************
// todo TUB-18950: after AB Test
// Remove
// - this part
// - remove all function-call of abTest Funktions
// - check for store.abTestIsTestPage
// - remove components in sso_ab_test
// - check for <template> ... abtest-remove-template-NOT/AND-content

import IntroductionText_sso_ab from "@/components/sso_ab_test/IntroductionText_sso_ab.vue";
// *************************************************** SSO AB-TEST END **********************************


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const { isMobile } = useIsMobile();

const benefits: Ref<{ benefitItems: []; benefitsBackgroundImageURL: string | undefined }> = ref({
	benefitItems: [],
	benefitsBackgroundImageURL: undefined,
});
let isFirstRequest = true;

watch(
	() => store.isLogin,
	() => {
		scrollContentToTop();
	}
);

const loginAreaSubscriberId = ref<number | null>(null);

onMounted(() => {
	showLoginOrRegister();
	if (!store.isClassic) {
		fetchBenefits()
			.then(async (response) => await response.json())
			.then((data: { benefitItems?: []; benefitsBackgroundImages?: [] }) => {
				benefits.value.benefitItems = data.benefitItems || [];
				benefits.value.benefitsBackgroundImageURL = buildBenefitsBackgroundImageURL(
					data.benefitsBackgroundImages || []
				);
			});
	}
	loginAreaSubscriberId.value = OcmMessenger.subscribe(messengerPublicationTypes.REQUEST_LOGIN, onRequestLogin, {
		REACT_TO_LATEST: true,
	});
});

const loginForm = ref<InstanceType<typeof LoginForm> | null>(null);
const socialLoginComponent = ref<typeof SocialLogin | null>(null);
const loginWrapper = ref<HTMLDivElement | null>(null);

onBeforeUnmount(() => {
	OcmMessenger.unsubscribe(loginAreaSubscriberId.value);
});

function closeLayer() {
	OcmMessenger.publish(messengerPublicationTypes.ABORTED_LOGIN);
	// send Tracking for Closing Layer
	const trackingAction = store.isLogin ? "LoginLayerClosed" : "RegistrationLayerClosed";
	pushEvent(trackingAction);
}

function scrollContentToTop() {
	if (loginWrapper.value) {
		loginWrapper.value.scrollTop = 0;
	}
}

function showLoginOrRegister() {
	// Prio 1: Seite mit In-Page-Registration-Button immer Registrieren
	// Prio 2: Url-Parameter urlParamLogin
	// Prio 3: Url-Parameter urlParamRegistration
	// Prio 4: localStorage (entweder gar nicht vorhanden oder "true" ist niemals "false"
	// Prio 5: modal immer LoginLandingpages, sonst (signinPage und inPageForm) immer Registrieren,

	const hasInPageRegistrationButton = !!document.querySelector("[data-registration=true]");
	const urlParamLogin = getParam("login") !== null;
	const urlParamRegistration = getParam("registration") !== null;
	const storageLoginActive = localStorage.getItem("loginTabActive") === "true";

	if (hasInPageRegistrationButton) {
		store.isLogin = false;
	} else if (urlParamLogin) {
		store.isLogin = true;
	} else if (urlParamRegistration) {
		store.isLogin = false;
	} else if (storageLoginActive) {
		store.isLogin = true;
	} else {
		store.isLogin = !!store.isModal;
	}
}

function getParam(paramName: string) {
	return new URLSearchParams(window.location.search).get(paramName);
}

function onRequestLogin() {
	if (isFirstRequest) {
		loginForm.value?.requestFirstLogin();
		isFirstRequest = false;
		return;
	}

	scrollContentToTop();
	loginForm.value?.clearFormData();
	store.globalErrorMessages = [];
	store.httpErrorStatusCode = null;
}

function fetchBenefits() {
	// fetchLabel mit URL nur an die Stelle von der es geholt wird (so dass rest.js allgemeiner ist)
	return fetch(`${window.ocm.config.encodedContextPath}/rest/login-layer/content`);
}

function buildBenefitsBackgroundImageURL(responsiveImages: []) {
	// select largest ImageURL from responsive Images
	const responsiveImagesObj: { SMALL?: string; MEDIUM?: string; LARGE?: string } = {};
	responsiveImages.forEach(
		(image: { url: string; resolutionType: "SMALL" | "MEDIUM" | "LARGE" }) =>
			(responsiveImagesObj[image.resolutionType] = image.url)
	);
	const imageURL = responsiveImagesObj["LARGE"] || responsiveImagesObj["MEDIUM"] || responsiveImagesObj["SMALL"];

	if (!imageURL) return;
	// check and add resourcesHostname
	const baseImageURL = window.ocm.config.resourcesHostname;

	return !baseImageURL ? imageURL : new URL(imageURL, baseImageURL).href;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw bg-white", {
			'relative h-screen w-full max-w-[1440px] overflow-hidden pt-[5.14285714rem] lg:p-0': _unref(store).isModal,
			' flex h-full flex-col': !_unref(store).isModal,
		}]),
    "data-track": _unref(store).isModal ? (_unref(store).isLogin ? 'LoginLayer' : 'RegistrationLayer') : undefined
  }, [
    (_unref(store).isModal)
      ? (_openBlock(), _createBlock(CloseButton, {
          key: 0,
          class: "absolute right-4 top-4 lg:right-6.5 lg:top-6.5",
          onClick: closeLayer
        }))
      : _createCommentVNode("", true),
    _createVNode(HeadlineModalMobil),
    _createElementVNode("div", {
      ref_key: "loginWrapper",
      ref: loginWrapper,
      class: _normalizeClass({ 'h-full w-full overflow-auto lg:grid lg:grid-cols-2': _unref(store).isModal })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([
					{ 'flex w-full flex-col lg:h-auto lg:w-auto': _unref(store).isModal },
					{ 'h-screen': _unref(store).isModal && !_unref(isMobile) },
				])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["mx-auto max-w-full text-sm", {
						'mb-12 mt-4 w-[432px] px-4 lg:mt-10 lg:flex-1': _unref(store).isModal,
						'mb-14 w-[400px] lg:mx-[unset]': !_unref(store).isModal && _unref(isMobile),
						'mb-8 w-[400px] lg:mx-[unset]': !_unref(store).isModal && !_unref(isMobile),
					}])
        }, [
          _createVNode(HeadlineModalDesktop),
          _createVNode(IntroductionText),
          _createVNode(LoginForm, {
            ref_key: "loginForm",
            ref: loginForm
          }, null, 512),
          _createVNode(SocialLogin, {
            ref_key: "socialLoginComponent",
            ref: socialLoginComponent
          }, null, 512)
        ], 2),
        _createElementVNode("aside", {
          class: _normalizeClass([{ 'bg-gray-20 pt-6': _unref(store).isModal, 'mx-4': _unref(store).isModal && _unref(isMobile) }, "px-4"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["mx-auto max-w-[400px] text-center", { 'lg:mx-[unset]': !_unref(store).isModal }])
          }, [
            _createVNode(BottomLoginRegisterToggle),
            (_unref(store).isModal && _unref(isMobile) && benefits.value.benefitItems.length)
              ? (_openBlock(), _createBlock(BenefitItems, {
                  key: 0,
                  class: "mb-8 text-left",
                  items: benefits.value.benefitItems
                }, null, 8, ["items"]))
              : _createCommentVNode("", true),
            (_unref(store).isModal)
              ? (_openBlock(), _createBlock(BaseTrust, {
                  key: 1,
                  class: "mb-8"
                }))
              : _createCommentVNode("", true)
          ], 2)
        ], 2),
        (_unref(store).isModal)
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              class: _normalizeClass([[{ 'bg-gray-20': !_unref(isMobile) && _unref(store).isModal }, { 'mt-10': _unref(isMobile) }], "w-full px-4"])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'lg:mx-[unset]': !_unref(store).isModal }, "mx-auto mb-4 max-w-[400px]"])
              }, [
                _createVNode(BaseFootnote)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 2),
      (_unref(store).isModal && !_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (benefits.value.benefitsBackgroundImageURL)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "h-full w-full object-cover",
                  src: benefits.value.benefitsBackgroundImageURL,
                  alt: "",
                  loading: "lazy"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (benefits.value.benefitItems.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(BenefitItems, {
                    class: "mx-auto w-fit border-[24px] border-[rgba(255,255,255,0.3)] bg-white bg-clip-padding px-7.5 py-9",
                    items: benefits.value.benefitItems
                  }, null, 8, ["items"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      (!_unref(store).isModal)
        ? (_openBlock(), _createBlock(BaseTrust, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})